<template>
    <Transition
        v-if="showNotification && show"
        enter="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enterFrom="translate-y-0 opacity-100 sm:translate-x-0"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
    >
        <div class="fixed bottom-0 left-0 right-0 z-30 flex items-start justify-center px-4 py-6 pointer-events-none sm:p-6">
            <div class="w-full max-w-sm rounded-lg shadow-lg pointer-events-auto tier-3-bg">
                <div class="overflow-hidden rounded-lg ring-1 ring-black ring-opacity-5">
                    <div class="p-4">
                        <div class="flex items-start">
                            <div class="shrink-0">
                                <svg
                                    data-description="info"
                                    class="w-5 h-5 info-svg-text"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <div class="ms-3 w-0 flex-1 pt-0.5">
                                <p class="text-sm font-medium leading-5 tier-3-text">
                                    {{ message }}
                                </p>
                            </div>

                            <div class="flex shrink-0 ms-4">
                                <tertiary-button
                                    @click="show = false"
                                    class="inline-flex transition duration-150 ease-in-out"
                                >
                                    <svg
                                        data-description="close"
                                        class="w-5 h-5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </tertiary-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script>
import TertiaryButton from '@/components/ui/UiTertiaryButton.vue';
export default {
    name: 'thing-info-notification',
    components: {
        TertiaryButton,
    },
    props: {
        message: {
            default: '',
        },
        showNotification: {
            default: false,
        },
    },
    data() {
        return {
            show: true,
        };
    },
};
</script>
